import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import * as R from 'ramda'
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import RegionComponent from '../components/region.component';
import { zones } from '../../../../../redux/zones/action';
import { employees } from '../../../../../redux/employees/action';
import { regions } from '../../../../../redux/route-management/regions/action';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import { selectZonesListItems } from '../../../../../redux/zones/selector';
import { selectEmployeesListItems } from '../../../../../redux/employees/selector';
import { selectTransportersListItems } from '../../../../../redux/transporters/selector';
import { selectRegionsQueryItems } from '../../../../../redux/route-management/regions/selector';
import { transporters } from '../../../../../redux/transporters/action';


const ManagementRegion = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const zoneLists = useSelector(selectZonesListItems)
  const employeeLists = useSelector(selectEmployeesListItems)
  const transporterLists = useSelector(selectTransportersListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const regionsQuery = useSelector(selectRegionsQueryItems)
  const [
    selectedRegions,
    setSelectedRegions
  ] = useState<any>([])


  const fetchRegionsQueryById = () => {
    dispatch(regions.query({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/route-management/regions/query`, entity: 'regions', jsonData: {

        Records: [
          {
            "Id": parmas?.id
          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    }).then(() => {
      setIsLoading(false)
    })




  }

  const handleInnerbasicFormChange: any = (event: any, field: string) => {
    setSelectedRegions({ ...selectedRegions, [field]: event })
  }



  useEffect(
    () => {
      dispatch(zones.list({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/zones/list`, entity: 'zones', jsonData: {}

      }))
        .then(() => {
          dispatch(employees.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/hrms/employees/list`, entity: 'employees', jsonData: {}
          }));
        }).then(() => {
          dispatch(transporters.list({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/transporters/list`, entity: 'transporters', jsonData: {}
          }))
        }).then(() => {
          if (parmas?.id > 0) {
            fetchRegionsQueryById()
            setIsLoading(false)
          } else {
            setIsLoading(false)
          }
        })
    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        setSelectedRegions(regionsQuery?.result?.items)

      }
    },
    [isQuery]
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();

    if (parmas?.id > 0) {
      await dispatch(regions.resetAction({ actionType: 'update' }))
      await dispatch(regions.update({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/route-management/regions`, entity: 'regions', jsonData: {

          Records: [
            selectedRegions

          ]

        }
      })).then(() => {
        back()
      })

    } else {
      await dispatch(regions.resetAction({ actionType: 'create' }))
      await dispatch(regions.create({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/route-management/regions`, entity: 'regions', jsonData: {

          Records: [
            selectedRegions
          ]

        }
      })).then(() => {
        back()
      })
    }

  }

  const back = () => {
    navigate('/management/route-management/regions')
  }


  return (
    <>
      {isLoading ? <PageLoader /> :


        <RegionComponent
          employees={employeeLists?.result?.items}
          transporters={transporterLists?.result?.items}
          zones={zoneLists?.result?.items}
          onInnerBasicFormChange={handleInnerbasicFormChange}
          selectedRegions={selectedRegions}
          back={back}
          handleFormSubmit={handleFormSubmit}
        />
      }

    </>
  )

}

export default ManagementRegion;